module.exports = __webpack_public_path__ + "img/portal1.cb16ac00.png";